<app-upload-files *ngIf="allowUpload && !isClaimArchived" [uploadFilesSettings]="uploadFilesSettings"
    (uploadedEvent)="newUploadedItem($event)">
</app-upload-files>

<app-loading-panel [isLoading]="isLoading"></app-loading-panel>

<div  *ngIf="claimPhotos && !isClaimArchived" class="photos-container">

    <div *ngIf="canRemove && claimPhotos?.length > 0" fxFlex="100" fxLayoutGap="10" fxLayoutAlign="end center">
        <input type="checkbox" [ngModel]="selectedAll" kendoCheckBox (change)="onSelectAll()" />
        <button kendoButton (click)="onButtonDelete()" icon="delete" class="button-with-margin">
        </button>
    </div>

    <div fxFlex="100" fxLayoutAlign="center center">
        <h2 *ngIf="claimPhotos?.length === 0">{{'mobile-center.noPhotos' | translate}} </h2>
    </div>

    <div class="selected-file" *ngFor="let file of claimPhotos">

        <div fxLayoutAlign="center center" fxLayout="column">
            <img role="none" class="img" [src]="getThumb(file)" [alt]="file.name" (click)="showContent(file)"
                alt="file" />
            <div>
                <span class="small-info" *ngIf="!!file.originalCreationDate">{{'mobile-center.creationOriginalDateShort'
                    | translate}} : {{file.originalCreationDate | date: 'yyyy-MM-dd HH:mm:ss'}}</span>
                <span class="small-info" *ngIf="!file.originalCreationDate">{{'mobile-center.storeDateShort' |
                    translate}} : {{file.timestamp | date: 'yyyy-MM-dd HH:mm:ss'}}</span>
                <span class="small-info" *ngIf="file.fileSize > 0"> ({{file.fileSize | filesize}})</span>
                
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start">
            <div>
                <input *ngIf="canRemove" type="checkbox" [ngModel]="file.isSelected" #notification kendoCheckBox
                    (change)="onCheckboxChange($event, file.id)" />
            </div>
        </div>
    </div>

</div>

<div class="photos-container" *ngIf="isClaimArchived">
    <strong>{{'claims-center.claimDocumentation.photosAreAlreadyArchived' | translate}}</strong>
</div>

<div kendoDialogContainer #photoContent></div>